if (typeof G === 'undefined') G = {};
G.Math = G.Math || {};

G.Math.Vector2 = function Vector2(optX, optY) {
	this.x = optX || 0;
	this.y = optY || 0;
};

G.Math.Vector2.prototype.set = function set(x, y) {
  this.x = x;
  this.y = y;
};

G.Math.Vector2.prototype.clone = function clone() {
  return new G.Math.Vector2(this.x, this.y);
};

G.Math.Vector2.prototype.copyFrom = function copyFrom(other) {
  this.x = other.x;
  this.y = other.y;
};
